import moment from 'moment'
import { DateRangeValue } from '@microservices/wiskey-react-components'

import { AUTOCOMPLETE_OPTIONS_DAILY_RANGE } from '@constants'

export const getDateTimeRange = (
  day: string
): string[] | [DateRangeValue, DateRangeValue] | undefined => {
  const createTimeRange = (startHours: number, endHours: number) => {
    const currentDate = moment()
    const today = currentDate.startOf('day')

    const startDate = today.clone().add(startHours, 'hour').toISOString() // 2025-04-08T21:00:00.000Z
    const endDate = today.clone().add(endHours, 'hour').add(-1, 'millisecond').toISOString() // 2025-04-09T20:59:59.999Z

    return [startDate, endDate]
  }

  if (day) {
    switch (day) {
      case AUTOCOMPLETE_OPTIONS_DAILY_RANGE.DAY_BEFORE_YESTERDAY: {
        return createTimeRange(-48, -24)
      }
      case AUTOCOMPLETE_OPTIONS_DAILY_RANGE.YESTERDAY: {
        return createTimeRange(-24, 0)
      }
      case AUTOCOMPLETE_OPTIONS_DAILY_RANGE.TODAY: {
        return createTimeRange(0, 24)
      }
      case AUTOCOMPLETE_OPTIONS_DAILY_RANGE.TOMORROW: {
        return createTimeRange(24, 48)
      }
      case AUTOCOMPLETE_OPTIONS_DAILY_RANGE.DAY_AFTER_TOMORROW: {
        return createTimeRange(48, 72)
      }
      default:
        return createTimeRange(0, 24)
    }
  }
}
